import { observer } from "mobx-react";
import React from "react";
import { Item } from "src/models";
import { IItem } from "src/types";
import { ActivityLog } from "./activityLog";


export interface IHistoryViewProps {
  item: Item<IItem>,
}

export const HistoryView = observer((props: IHistoryViewProps): JSX.Element => {
  return (
    <>
      <ActivityLog/>
    </>
  );
});

